export default __webpack_public_path__ + "static/media/marauders-map-v4-04-04.daf66f7d.jpg";